import type { LaserficheInspectField } from "@repo/types";
import { useMemo } from "react";

export const useFieldMapping = (availableFields: LaserficheInspectField[]) =>
  useMemo(
    () =>
      availableFields.reduce(
        (map, field) => ((map[field.id] = field), map),
        Object.create(null) as Record<number, LaserficheInspectField>
      ),
    [availableFields]
  );
